import React from 'react';
import classNames from 'classnames';
import { TableCellAlignment } from '@packages/ui/table/table-type.ts';

export default function TableHeaderColumn(props: {
  children?: React.ReactNode;
  className?: string;
  alignment?: TableCellAlignment;
}) {
  return (
    <th
      scope="col"
      className={classNames(
        'pl-2 pr-2 text-left text-sm font-semibold text-gray-900 md:pl-6 md:pr-3',
        {
          'text-left': props.alignment === TableCellAlignment.Left,
          'text-right': props.alignment === TableCellAlignment.Right,
          'text-center': props.alignment === TableCellAlignment.Center,
        },
        props.className
      )}
    >
      {props.children}
    </th>
  );
}
